import React from 'react';
import { useTranslation } from 'react-i18next';

// components
import Chatbar from 'eCoach/chatbar/Chatbar';
import ChatBubble from 'eCoach/ChatBubble';
import { Stack } from '@mui/material';

// utils
import { UserInputType } from 'eCoach/utils';

interface ChatGuideData {
  displayPolicyHelper?: boolean;
  displayPolicyPrompt?: boolean;
  displayUnionPrompt?: boolean;
  displayPromptHelper: boolean;
  chatStartEnded: boolean;
  inProgress: boolean;
  promptHelperGoal: string | null | any;
  promptHelperTheme: string | null;
}

interface UnionHelperProps {
  handleChatGuidance: (updates: Partial<ChatGuideData>) => void;
  sendUserInput: (userInput: string, type: number) => void;
}

export default function UnionHelper({
  handleChatGuidance,
  sendUserInput,
}: UnionHelperProps): JSX.Element {
  const { t } = useTranslation('pageEcoach');

  const onChallengeSubmission = (userInput: string): void => {
    const updates: Partial<ChatGuideData> = {
      inProgress: false,
      chatStartEnded: true,
      displayUnionPrompt: false,
    };

    handleChatGuidance(updates);

    // For union questions, combine the original prompt with the user's response
    const combinedInput = `${t(
      'chatStart.According to the union'
    )}: ${userInput}`;
    sendUserInput(combinedInput, UserInputType.INITIAL_PROMPT);
  };

  return (
    <Stack
      spacing={3}
      style={{ flex: 1, justifyContent: 'space-between', position: 'relative' }}
    >
      <div
        style={{
          display: 'flex',
          height: '100%',
          flexDirection: 'column',
        }}
      >
        <ChatBubble
          sentByUser
          simpleString={t(
            'chatStart.I need information about my union documents'
          )}
        />
        <ChatBubble simpleString={t('chatStart.UnionFollowUp')} />
      </div>
      <Chatbar onSubmit={onChallengeSubmission} />
    </Stack>
  );
}
